import { render, staticRenderFns } from "./TabTextureColor.vue?vue&type=template&id=14ca15e7&scoped=true&"
import script from "./TabTextureColor.vue?vue&type=script&lang=ts&"
export * from "./TabTextureColor.vue?vue&type=script&lang=ts&"
import style0 from "./TabTextureColor.vue?vue&type=style&index=0&id=14ca15e7&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14ca15e7",
  null
  
)

export default component.exports